<template>
  <v-row>
    <v-col class="mt-0 pt-0">
      <v-checkbox
        v-model="searchActive"
        label="Dossier déposé sur la période: "
      >
      </v-checkbox>
    </v-col>
    <v-col class="mt-0 pt-0">
      <v-menu
        ref="menuDateMin"
        v-model="menuDateMin"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="formattedChosenDateMin"
            label="Après"
            prepend-icon="event"
            readonly
            v-on="on"
            :disabled="!searchActive"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="newDateMin"
          locale="fr"
          @input="menuDateMin = false"
        ></v-date-picker>
      </v-menu>
    </v-col>
    <v-col class="mt-0 pt-0">
      <v-menu
        ref="menuDateMax"
        v-model="menuDateMax"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="formattedChosenDateMax"
            label="Avant"
            prepend-icon="event"
            readonly
            v-on="on"
            :disabled="!searchActive"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="newDateMax"
          locale="fr"
          @input="menuDateMax = false"
        ></v-date-picker>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "SearchDateWidget",
  props: ["searchOnDate", "dateMin", "dateMax"],
  data() {
    return {
      menuDateMin: false,
      menuDateMax: false
    };
  },
  computed: {
    searchActive: {
      get() {
        return this.searchOnDate;
      },
      set(value) {
        this.$emit("update:searchOnDate", value);
      }
    },
    newDateMin: {
      get() {
        return this.getPickerDate(this.dateMin);
      },
      set(value) {
        //Ne pas oublier de prendre en compte la timezone pour les comparaisons
        this.$emit("update:dateMin", Date.parse(value + "T00:00:00.000+02:00"));
      }
    },
    newDateMax: {
      get() {
        return this.getPickerDate(this.dateMax);
      },
      set(value) {
        this.$emit("update:dateMax", Date.parse(value + "T00:00:00.000+02:00"));
      }
    },
    formattedChosenDateMin() {
      return this.getLocalizedDate(this.dateMin);
    },
    formattedChosenDateMax() {
      return this.getLocalizedDate(this.dateMax);
    }
  },
  methods: {
    getPickerDate(timestamp) {
      if (timestamp) {
        const date = new Date(timestamp);
        return (
          date.getFullYear() +
          "-" +
          this.pad(date.getMonth() + 1) +
          "-" +
          date.getDate()
        );
      }
      return null;
    },
    getLocalizedDate(timestamp) {
      if (timestamp) {
        let date = new Date(timestamp);
        return date.toLocaleDateString();
      }
      return null;
    },
    pad(s) {
      return s <= 9 ? "0" + s : "" + s;
    }
  }
};
</script>

<style></style>
